import NoBattle from "./NoBattle";

export default NoBattle;
